import { render, staticRenderFns } from "./hzcontactedit.vue?vue&type=template&id=0d28dfd6&"
import script from "./hzcontactedit.vue?vue&type=script&lang=ts&"
export * from "./hzcontactedit.vue?vue&type=script&lang=ts&"
import style0 from "./hzcontactedit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports